<template>
    <div class="w-[90%] mx-auto mt-[20px]">
        <div v-if="errorValidationFlag" class="absolute flex flex-col left-[50%] translate-x-[-50%] px-[20px] justify-evenly top-[50%] translate-y-[-50%] ml-[150px] rounded-[10px] w-[300px] h-[200px] bg-[#252526]">
            <div class="flex justify-center items-center">
                <div class="text-white text-[16px] text-center font-semibold">
                    В тренуванні є незаповнені поля або елементи з не вказаним часом
                </div>
            </div>
            <div @click="errorValidationFlag = false" class="bg-[#BD9135] text-center cursor-pointer text-white font-semibold py-[5px] rounded-lg mt-[15px]">
                OK
            </div>
        </div>
        <div class="flex flex-col justify-between">
            <div class="text-[#BD9135] font-bold text-[14px] mb-[6px]">Команда</div>
            <div class="flex items-stretch">
                <draggable
                    v-model="elements"
                    item-key="current_id"
                    class="line border-[1px] rounded-[10px] w-full flex h-[35px] overflow-hidden"
                    ghost-class="bg-[#3a3a3a]"
                    :animation="150"
                    @end="handleReorder"
                >
                    <template #item="{ element, index }">
                        <div 
                            @click="elementViewFlag = true; selectedElement = element; activeTimeline = 'player'" 
                            class="relative h-full flex justify-center items-center cursor-pointer px-[10px] bg-[#BD9135] border-x-[1px] border-black" 
                            :style="getPlayerElementStyle(element)"
                            :class="{'opacity-[0.6]' : !element.time, 'bg-[#339989]': selectedElement.current_id === element.current_id && elementViewFlag}"
                            :title="element.name"
                        >
                            <button
                                v-if="!isGoalkeeperTrainer"
                                class="absolute right-1 top-[50%] translate-y-[-50%] w-[18px] h-[18px] rounded-full bg-[#252526] text-white text-[12px] flex items-center justify-center hover:bg-[#DA4167]"
                                @click.stop="deleteElementFromTimeline(element, 'player')"
                                title="Видалити елемент"
                            >×</button>
                            <div class="text-black text-center text-[1rem] flex items-center overflow-hidden whitespace-nowrap overflow-ellipsis">
                                <div>{{ getElementDisplayName(element) }}</div>
                                <svg v-if="!element.time" class="ml-[10px]" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_23_10)">
                                    <circle cx="8.5" cy="8.5" r="6.25" stroke="black" stroke-width="1.5"/>
                                    <path d="M8.5 6V8.5L9.75 9.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <path d="M16 1L1 16" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                    <defs>
                                    <clipPath id="clip0_23_10">
                                    <rect width="15" height="15" fill="black" transform="translate(1 1)"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </template>
                </draggable>

                <div v-if="!isGoalkeeperTrainer && !isIndividualTrainer" @click="activeTimeline = 'player'; showElements = true; elementViewFlag = false" class="text-center w-[30px] h-full cursor-pointer text-[21px] text-white">+</div>
            </div>
            <div class="text-white text-center mt-[12px]">{{timelineTime}} ЗАГАЛЬНИЙ ЧАС</div>

            <div class="text-[#339989] font-bold text-[14px] mt-[20px] mb-[6px]">Індивідуальна робота</div>
            <div class="flex items-stretch">
                <div class="line border-[1px] rounded-[10px] w-full relative h-[35px] overflow-hidden">
                    <div
                        v-for="element in goalkeeperElements"
                        :key="element.current_id"
                        @mousedown="startDragGk($event, element)"
                        @click="elementViewFlag = true; selectedElement = element; activeTimeline = 'goalkeeper'"
                        class="absolute top-0 h-full flex justify-center items-center cursor-grab px-[10px] bg-[#339989] border-x-[1px] border-black select-none"
                        :style="getGkRailStyle(element)"
                        :class="{'opacity-[0.6]' : !element.time, 'bg-[#BD9135]': selectedElement.current_id === element.current_id && elementViewFlag, 'z-[10]': draggingGkId === element.current_id}"
                        :title="element.name"
                    >
                        <button
                            class="absolute right-1 top-[50%] translate-y-[-50%] w-[18px] h-[18px] rounded-full bg-[#252526] text-white text-[12px] flex items-center justify-center hover:bg-[#DA4167]"
                            @click.stop="deleteElementFromTimeline(element, 'goalkeeper')"
                            title="Видалити елемент"
                        >×</button>
                        <div class="text-black text-center text-[1rem] flex items-center overflow-hidden whitespace-nowrap overflow-ellipsis">
                            <div>{{ getElementDisplayName(element) }}</div>
                            <svg v-if="!element.time" class="ml-[10px]" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_23_10)">
                                <circle cx="8.5" cy="8.5" r="6.25" stroke="black" stroke-width="1.5"/>
                                <path d="M8.5 6V8.5L9.75 9.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <path d="M16 1L1 16" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                                <defs>
                                <clipPath id="clip0_23_10">
                                <rect width="15" height="15" fill="black" transform="translate(1 1)"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                </div>

                <div v-if="canEditGoalkeeperTimeline" @click="activeTimeline = 'goalkeeper'; showElements = true; elementViewFlag = false" class="text-center w-[30px] h-full cursor-pointer text-[21px] text-white">+</div>
            </div>
            <div class="text-white text-center mt-[12px]">{{goalkeeperTimelineTime}} ЗАГАЛЬНИЙ ЧАС</div>

            <div v-if="!showElements && !elementViewFlag">
                <div class="mt-4 text-start flex">
                    <div class="w-[70%] mr-[20px]">
                        <div class="text-[#BD9135] text-[14px] font-bold">Опис тренування</div>
                        <textarea 
                            v-model="trainingDescription" 
                            :disabled="isGoalkeeperTrainer || isIndividualTrainer"
                            class="w-full h-[350px] border-[1px] border-white border-opacity-10 outline-none text-white bg-transparent rounded-[10px] p-[10px]" 
                            placeholder="Введіт опис..."
                            :class="{
                                'border-[#DA4167] border-[3px]': !validation.description,
                                'opacity-50 cursor-not-allowed': isGoalkeeperTrainer || isIndividualTrainer
                            }"     
                        ></textarea>
                    </div>
                    <div class="w-[30%]">
                        <div class="w-[100%] flex flex-col items-start justify-start mb-3">
                            <div class="text-[#BD9135] text-[14px] font-bold">Назва тренування</div>
                            <input 
                                v-model="trainingName" 
                                class="bg-[#252526] outline-none text-white border-[1px] border-white border-opacity-10 text-[18px] w-[100%] py-[5px] px-[5px] rounded-[6px]" 
                                placeholder="Введіть назву..."
                                :class="{
                                    'border-[#DA4167] border-[3px]': !validation.name
                                }"         
                            >    
                        </div>
                        <div class="w-[100%] flex flex-col items-start justify-start">
                            <div class="text-[#BD9135] text-[14px] font-bold">Вікова група</div>
                            <select 
                                v-model="trainingAgeGroup" 
                                class="bg-[#252526] outline-none text-white  text-[18px] w-[100%] py-[5px] px-[5px] rounded-[6px]"
                                :class="{
                                    'text-[#8C8C8C]': trainingAgeGroup === '',
                                    'border-[#DA4167] border-[3px] ': !validation.ageGroup
                                }"    
                            >
                                <option value="" disabled>Виберіть вікову категорію</option>
                                <option class="text-white" value="6_years">6 років</option>
                                <option class="text-white" value="7_years">7 років</option>
                                <option class="text-white" value="8_years">8 років</option>
                                <option class="text-white" value="9_years">9 років</option>
                                <option class="text-white" value="10_years">10 років</option>
                                <option class="text-white" value="11_years">11 років</option>
                                <option class="text-white" value="12_years">12 років</option>
                                <option class="text-white" value="13_years">13 років</option>
                                <option class="text-white" value="14_years">14 років</option>
                                <option class="text-white" value="15_years">15 років</option>
                                <option class="text-white" value="16_years">16 років</option>
                                <option class="text-white" value="17_years">17 років</option>
                                <option class="text-white" value="18_years">18 років</option>
                                <option class="text-white" value="19_years">19 років</option>
                                <option class="text-white" value="20_years">20 років</option>
                                <option class="text-white" value="21_years">21 років</option>
                                <option class="text-white" value="22_years">22 років</option>
                                <option class="text-white" value="23_years">23 років</option>
                                <option class="text-white" value="main_team">Основна команда</option>
                            </select>    
                        </div>
                        <!-- <div class="w-[100%] flex flex-col items-start justify-start">
                            <div class="bg-[#252526] text-[#BD9135] cursor-pointer mt-[20px] border-[1px] text-center border-[#BD9135] text-[18px] w-[100%] py-[3px] px-[5px] rounded-[6px]">Додати до програми</div>
                        </div> -->
                        <!-- <div class="w-[100%] flex flex-col items-start justify-start">
                            <div @click="" class="bg-[#339989] text-[#252526] cursor-pointer mt-[20px] border-[1px] text-center border-[#339989] text-[18px] w-[100%] py-[3px] px-[5px] rounded-[6px]">Завершити тренування</div>
                        </div> -->
                        <div class="w-[100%] flex flex-col items-start justify-start">
                            <div @click="updateTrainingSummary" class="bg-[#BD9135] text-[#252526] cursor-pointer mt-[20px] border-[1px] text-center border-[#BD9135] text-[18px] w-[100%] py-[3px] px-[5px] rounded-[6px]">Зберегти</div>
                            <div @click="$emit('close')" class="bg-[#BD9135] text-[#252526] cursor-pointer mt-[20px] border-[1px] text-center border-[#BD9135] text-[18px] w-[100%] py-[3px] px-[5px] rounded-[6px]">Назад</div>
                            <div @click="uploadPdfSummary" class="bg-[#BD9135] text-[#252526] cursor-pointer mt-[20px] border-[1px] text-center border-[#BD9135] text-[18px] w-[100%] py-[3px] px-[5px] rounded-[6px]">Завантажити PDF</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="showElements && !elementViewFlag">
                <div class="flex items-center justify-between mt-[20px]">
                    <input 
                        v-model="searchQuery" 
                        class="bg-transparent text-[#FFF] border-[1px] border-[#474849] rounded-md px-3 py-2 outline-none w-[250px]" 
                        placeholder="Пошук елементів..."
                        type="text"
                    />
                    <div class="flex items-center text-white gap-3">
                        <button @click="prevPage" class="w-[36px] h-[36px] border border-[#474849] rounded-[6px] flex items-center justify-center hover:bg-[#474849]">‹</button>
                        <div class="text-sm">Сторінка {{ page }} / {{ maxPage }}</div>
                        <button @click="nextPage" class="w-[36px] h-[36px] border border-[#474849] rounded-[6px] flex items-center justify-center hover:bg-[#474849]">›</button>
                    </div>
                </div>
                <div class="flex flex-wrap gap-3 mt-4">
                    <button
                        v-for="block in blockOptions"
                        :key="block"
                        @click="selectedBlock = selectedBlock === block ? null : block"
                        class="px-3 py-2 rounded-md text-sm"
                        :class="selectedBlock === block ? 'bg-[#BD9135] text-black' : 'bg-[#3a3a3a] text-white'"
                    >
                        {{ block }}
                    </button>
                    <button
                        v-if="selectedBlock"
                        @click="selectedBlock = null"
                        class="px-3 py-2 rounded-md text-sm bg-[#474849] text-white"
                    >
                        Скинути блок
                    </button>
                </div>
                <div class="w-[100%] flex flex-col items-center justify-center">
                    <div @click="showElements = false" class="bg-[#BD9135] text-[#252526] cursor-pointer mt-[20px] border-[1px] text-center border-[#BD9135] text-[18px] w-[20%] py-[3px] px-[5px] rounded-[6px]">Назад</div>
                </div>
                <table class="w-full mt-[20px]">
                    <thead class="text-white select-none">
                        <tr class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                            <th class="px-3 py-2 w-[5%] text-center font-bold text-sm"></th>
                            <th class="px-3 py-2 w-[20%] text-start font-bold text-sm">Назва елементу</th>
                            <th class="px-3 py-2 w-[10%] text-center font-bold text-sm">Елемент</th>
                            <th class="px-3 py-2 w-[10%] text-end font-bold text-sm">Блок елементу</th>
                            <th class="w-[15%] py-2 cursor-pointer select-none text-end font-bold text-sm">
                                Тривалість
                            </th>
                            <th class="w-[5%]" ></th>
                            <th class="px-3 py-2 text-end w-[204px] relative font-bold text-sm">
                                Оцінювання
                            </th>
                            <th class="px-3 w-[25%] py-2 text-end font-bold text-sm"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="element in filteredTrainingElements" class="border-b-[1px] border-[#FFF] border-opacity-10 text-white">
                            <td class="px-3 py-2 w-[5%] text-center font-medium text-sm">
                                <div class="rounded-full border-[1px] bg-[#BD9135] border-white w-[50px] h-[50px] flex justify-center items-center text-center align-middle">
                                    <span class="text-[21px]">{{ element.name ? element.name[0].toUpperCase() : 'N' }}</span>
                                </div>
                            </td>
                            <td class="px-3 py-2 w-[20%] text-start font-medium text-sm">{{ element.name ? element.name : 'Немає назви' }}</td>
                            <td class="px-3 py-2 w-[10%] text-center font-medium text-sm text-[#BD9135]">{{ parseElementType(element.type) }}</td>
                            <td class="px-3 py-2 w-[10%] text-end font-medium text-sm">{{ parseAgeGroup(element.training_program_years) }}</td>
                            <td class="w-[15%] py-2 select-none text-end font-medium text-sm">
                                {{ element.time ?? 'Налаштовувана' }}
                            </td>
                            <td class="w-[5%]" ></td>
                            <td class="px-3 py-2 text-end w-[204px] relative font-medium text-sm">
                                {{ element.type == 'task' ? '-' : parseScoring(element.score_board_type) }}
                            </td>
                            <td class="px-3 w-[25%] py-2 text-end font-medium text-sm">
                                <button 
                                class="py-1 rounded-[10px] text-sm font-medium text-red-600"
                                @click="addElementToTraining(element)"
                                >
                                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="13" cy="13" r="13" fill="#339989"/>
                                    <line x1="13" y1="5" x2="13" y2="21" stroke="white" stroke-width="2"/>
                                    <line x1="5" y1="13" x2="21" y2="13" stroke="white" stroke-width="2"/>
                                </svg>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else-if="elementViewFlag" class="mt-[100px]">
                <ElementView 
                    @back="elementViewFlag = false" 
                    @changeTime="changeTimeSelectedElement" 
                    @changeApproaches="changeApproachesSelectedElement"
                    @changeRest="changeRestSelectedElement"
                    @deleteElement="deleteElementFromTimeline" 
                    :element="selectedElement" 
                    :key="selectedElement"
                    :training="training"
                    :canDelete="!(isGoalkeeperTrainer && activeTimeline === 'player')"
                />
            </div>
        </div> 
    </div>
</template>

<script>
    import { ref, onMounted, computed, watch } from 'vue'
    import { getAllTrainingElementsRequest, getStatisticsByElements, getTrainingSummaryPdf } from '@/desktopApp/services/apiRequests'
    import { useMainStore } from '@/desktopApp/stores/mainStore'
    import ElementView from './ElementView.vue'
    import draggable from 'vuedraggable'

    export default {
        name: 'TrainingForm',

        props: {
            summary: {
                type: Object,
                default: () => ({})
            },
            training: {
                type: Object,
                default: () => ({})
            }
        },

        setup(props, { emit }) {
            const store = useMainStore()

            const isMethodist = computed(() => {
                const position = (store.trainer_position || '').toLowerCase()
                return position.includes('метод') || position.includes('method')
            })

            const isGoalkeeperTrainer = computed(() => {
                const position = (store.trainer_position || '').toLowerCase()
                return position.includes('goalkeeper_trainer')
            })

            const isIndividualTrainer = computed(() => {
                const position = (store.trainer_position || '').toLowerCase()
                return position.includes('individual_trainer')
            })

            const canEditGoalkeeperTimeline = computed(() => {
                return isMethodist.value || isGoalkeeperTrainer.value || isIndividualTrainer.value
            })

            const ageGroup = ref('6_years')
            const showElements = ref(false)

            const allTrainingElements = ref([])
            const trainingElements = ref([])

            const nextElementId = ref(1)
            const buildElementsWithIds = (list = []) => {
                let maxId = 0
                const normalized = list.map((el, index) => {
                    const currentId = el.current_id ?? index + 1
                    maxId = Math.max(maxId, currentId)
                    return {
                        ...el,
                        current_id: currentId
                    }
                })
                nextElementId.value = maxId + 1
                return normalized
            }

            const elements = ref(buildElementsWithIds(props.summary?.elements || []))
            const goalkeeperElements = ref(buildElementsWithIds(props.summary?.goalkeeper_elements || []))
            const minutes = ref(0)
            const hours = ref(0)

            const activeTimeline = ref('player')
            const selectedElement = ref({})

            const elementViewFlag = ref(false)

            const searchQuery = ref('')
            const page = ref(1)
            const maxPage = ref(1)
            const selectedBlock = ref(null)

            const goalkeeperBlockOptions = [
                'Захист воріт',
                'Захист зони',
                'Захист простору',
                'Гра 1VS1',
                'Початок атаки + пас назад',
                'Спортзал'
            ]

            const defaultBlockOptions = [
                'Блок оборони-атаки',
                'Блок малі групи',
                'Блок великі групи',
                'Блок квадратів',
                'Блок удари-завершення',
                'Блок технічний',
                'Блок тактичний',
                'Блок профілактики травматизму/зміцнення',
                'Блок швидкісно-силової спрямованості',
                'Блок спеціальної витривалості',
                'Домашнє завдання',
                'Блок швидких атак',
                'Спортзал'
            ]

            const blockOptions = computed(() => {
                return isGoalkeeperTrainer.value
                    ? goalkeeperBlockOptions
                    : defaultBlockOptions
            })

            const trainingName = ref(props.summary?.name ? props.summary?.name : '')
            const trainingDescription = ref(props.summary?.info ? props.summary?.info : '')
            const trainingAgeGroup = ref(props.summary?.age_group ? props.summary?.age_group : '')

            const errorValidationFlag = ref(false)

            const validation = ref({
                name: true,
                ageGroup: true,
                description: true,
                exercises: true
            })

            const filters = ref({
                elementType: 'all',
                ageCategory: 'all',
                assessmentType: 'all',
                direction: 'all',
                timeSort: 'none',
            })

            const updateElements = async () => {
                const response = await getAllTrainingElementsRequest(
                    20 * page.value,
                    20 * (page.value - 1),
                    filters.value,
                    searchQuery.value
                )
                trainingElements.value = response
                allTrainingElements.value = response
            }

            const prevPage = () => {
                page.value = page.value > 1 ? page.value - 1 : 1
            }

            const nextPage = () => {
                page.value = page.value < maxPage.value ? page.value + 1 : maxPage.value
            }

            const filteredTrainingElements = computed(() => trainingElements.value)

            watch(page, async () => {
                await updateElements()
            })

            watch(searchQuery, async () => {
                page.value = 1
                await updateElements()
            })

            watch(selectedBlock, async (val) => {
                filters.value = {
                    ...filters.value,
                    ageCategory: val ?? 'all'
                }
                page.value = 1
                await updateElements()
            })

            watch(() => trainingName.value, (newValue) => {
                validation.value.name = !!newValue
            })

            watch(() => trainingAgeGroup.value, (newValue) => {
                validation.value.ageGroup = !!newValue
            })

            watch(() => trainingDescription.value, (newValue) => {
                validation.value.description = !!newValue
            })

            const checkValidation = () => {
                if (!trainingName.value) {
                    validation.value.name = false
                } else {
                    validation.value.name = true
                }

                if (!trainingAgeGroup.value) {
                    validation.value.ageGroup = false
                } else {
                    validation.value.ageGroup = true
                }

                validation.value.description = true

                if (!elements.value.length) {
                    validation.value.exercises = false
                } else {
                    validation.value.exercises = true
                }

                if (elements.value.some(el => !el.time)) {
                    validation.value.exercises = false
                } else { 
                    validation.value.exercises = true
                }
            }

            const timelineTime = computed(() => {
                let minutesTimeline = 0
                let hoursTimeline = 0 
                elements.value.forEach(el => {
                    minutesTimeline += +el.time
                })

                if (minutesTimeline >= 60) {
                    hoursTimeline += Math.floor(minutesTimeline / 60)
                    minutesTimeline = minutesTimeline % 60
                }

                return `${hoursTimeline}:${minutesTimeline}`
            })

            onMounted(async () => {
                const statistics = await getStatisticsByElements()
                const total = (statistics?.standard || 0) + (statistics?.exercise || 0) + (statistics?.task || 0)
                maxPage.value = Math.max(1, Math.ceil(total / 20))

                await updateElements()

                elements.value.forEach(el => {
                    if (el.time) {
                        minutes.value += +el.time
                    }
                })
                if (minutes.value >= 60) {
                    hours.value += Math.floor(minutes.value / 60)
                    minutes.value = minutes.value % 60
                }
            })

            const addTraining = async () => {
                checkValidation()

                if (!Object.values(validation.value).some(el => !el)) {
                    emit('saveTraining', {
                        name: trainingName.value,
                        info: trainingDescription.value,
                        age_group: trainingAgeGroup.value,
                        elements: elements.value
                    })
                } else {
                    console.log('Validation error')
                    errorValidationFlag.value = true
                }
            }

            const addElementToTraining = async (elementObject) => {
                const targetArray = activeTimeline.value === 'goalkeeper' ? goalkeeperElements : elements
                targetArray.value.push({
                    ...elementObject,
                    current_id: nextElementId.value++
                })
                minutes.value += +elementObject?.time
                if (minutes.value >= 60) {
                    hours.value += Math.floor(minutes.value / 60)
                    minutes.value = minutes.value % 60
                }
            }

            const parseElementType = (type) => {
                switch (type) {
                    case 'standard':
                        return 'Норматив'
                    case 'exercise':
                        return 'Вправа'
                    case 'task':
                        return 'Завдання'
                    default:
                        return 'Невідомий тип елементу'
                }
            }

            const parseAgeGroup = (ageGroup) => {
                switch (ageGroup) {
                    case '6_years':
                        return 'Невідомий блок'
                    case '7_years':
                        return 'Невідомий блок'
                    case '8_years':
                        return 'Невідомий блок'
                    case '9_years':
                        return 'Невідомий блок'
                    case '10_years':
                        return 'Невідомий блок'
                    case '11_years':
                        return 'Невідомий блок'
                    case '12_years':
                        return 'Невідомий блок'
                    case '13_years':
                        return 'Невідомий блок'
                    case '14_years':
                        return 'Невідомий блок'
                    case '15_years':
                        return 'Невідомий блок'
                    case '16_years':
                        return 'Невідомий блок'
                    case '17_years':
                        return 'Невідомий блок'
                    case '18_years':
                        return 'Невідомий блок'
                    case '19_years':
                        return 'Невідомий блок'
                    case '20_years':
                        return 'Невідомий блок'
                    case '21_years':
                        return 'Невідомий блок'
                    case '22_years':
                        return 'Невідомий блок'
                    case '23_years':
                        return 'Невідомий блок'
                    case 'main_team':
                        return 'Невідомий блок'
                    default:
                        return ageGroup
                }
            }

            const parseScoring = (scoring) => {
                switch (scoring) {
                    case 'time':
                        return 'Час'
                    case 'point':
                        return 'Оцінка'
                    case 'length':
                        return 'Відстань'
                    default:
                        return '-'
                }
            }

            const deleteElementFromTimeline = (element, timeline) => {
                const targetArray = timeline === 'goalkeeper' ? goalkeeperElements : elements
                const index = targetArray.value.indexOf(element)
                if (index !== -1) {
                    targetArray.value.splice(index, 1)
                }
                minutes.value -= +element?.time
                if (minutes.value < 0) {
                    hours.value -= Math.floor(minutes.value / 60)
                    minutes.value = 60 + (minutes.value % 60)
                }
                elementViewFlag.value = false
                selectedElement.value = {}
            }

            const getFulltimeOfElements = () => {
                let minutes = 0
                elements.value.forEach(el => {
                    minutes += +el.time
                })
                return minutes
            }

            const isElementsWithoutTime = () => {
                return elements.value.some(el => !el.time)
            }

            const getFulltimeOfGoalkeeperElements = () => {
                let minutes = 0
                goalkeeperElements.value.forEach(el => {
                    minutes += +el.time
                })
                return minutes
            }

            const isGoalkeeperElementsWithoutTime = () => {
                return goalkeeperElements.value.some(el => !el.time)
            }

            const goalkeeperTimelineTime = computed(() => {
                let minutesTimeline = 0
                let hoursTimeline = 0 
                goalkeeperElements.value.forEach(el => {
                    minutesTimeline += +el.time
                })
                if (minutesTimeline >= 60) {
                    hoursTimeline += Math.floor(minutesTimeline / 60)
                    minutesTimeline = minutesTimeline % 60
                }
                return `${hoursTimeline}:${minutesTimeline}`
            })

            const changeTimeSelectedElement = (time) => {
                minutes.value -= +selectedElement.value.time
                minutes.value += +time
                if (minutes.value >= 60) {
                    hours.value += Math.floor(minutes.value / 60)
                    minutes.value = minutes.value % 60
                }
                selectedElement.value.time = time
            }

            const changeApproachesSelectedElement = (value) => {
                selectedElement.value.approachesNumber = value
                const target = elements.value.find(el => el.current_id === selectedElement.value.current_id)
                if (target) {
                    target.approachesNumber = value
                }
            }

            const changeRestSelectedElement = (value) => {
                selectedElement.value.approachesBreak = value
                const target = elements.value.find(el => el.current_id === selectedElement.value.current_id)
                if (target) {
                    target.approachesBreak = value
                }
            }

            const getGkElementsWithPositions = () => {
                return goalkeeperElements.value.map(el => ({
                    ...el,
                    timeline_position: gkPositionMap.value[el.current_id] ?? 0
                }))
            }

            const updateTrainingSummary = () => {
                checkValidation()
                if (!Object.values(validation.value).some(el => !el)) {
                    const newTrainingObject = {
                        name: trainingName.value,
                        info: trainingDescription.value,
                        age_group: trainingAgeGroup.value,
                        elements: elements.value,
                        goalkeeper_elements: getGkElementsWithPositions()
                    } 
                    emit('saveTraining', { training: newTrainingObject })
                } else {
                    console.log('Validation error')
                    errorValidationFlag.value = true
                }
            }

            const syncLayout = computed(() => {
                const pElems = elements.value
                const gElems = goalkeeperElements.value

                if (pElems.length === 0 || gElems.length === 0) return null
                if (pElems.some(el => !el.time) || gElems.some(el => !el.time)) return null

                const totalTime = pElems.reduce((s, el) => s + (+el.time), 0)
                    + gElems.reduce((s, el) => s + (+el.time), 0)

                return { totalTime }
            })

            const gkPositionMap = ref({})
            goalkeeperElements.value.forEach(el => {
                if (el.timeline_position !== undefined) {
                    gkPositionMap.value[el.current_id] = el.timeline_position
                }
            })
            const draggingGkId = ref(null)

            const getGkElementWidth = (element) => {
                if (syncLayout.value) {
                    return (+element.time / syncLayout.value.totalTime) * 100
                }
                const fullTime = getFulltimeOfGoalkeeperElements()
                if (!fullTime || isGoalkeeperElementsWithoutTime()) {
                    return 100 / Math.max(1, goalkeeperElements.value.length)
                }
                return (+element.time / fullTime) * 100
            }

            const getGkPosition = (element) => {
                if (gkPositionMap.value[element.current_id] === undefined) {
                    let maxRight = 0
                    goalkeeperElements.value.forEach(el => {
                        if (el.current_id !== element.current_id && gkPositionMap.value[el.current_id] !== undefined) {
                            maxRight = Math.max(maxRight, gkPositionMap.value[el.current_id] + getGkElementWidth(el))
                        }
                    })
                    gkPositionMap.value[element.current_id] = Math.min(maxRight, 100 - getGkElementWidth(element))
                }
                return gkPositionMap.value[element.current_id]
            }

            const getGkRailStyle = (element) => {
                const width = getGkElementWidth(element)
                const left = getGkPosition(element)
                return {
                    width: width + '%',
                    left: left + '%'
                }
            }

            const startDragGk = (event, element) => {
                if (event.button !== 0) return
                const container = event.target.closest('.line')
                if (!container) return
                const rect = container.getBoundingClientRect()
                const startX = event.clientX
                const startLeft = getGkPosition(element)
                const width = getGkElementWidth(element)
                draggingGkId.value = element.current_id
                let moved = false

                const onMouseMove = (e) => {
                    moved = true
                    const dx = e.clientX - startX
                    const dxPercent = (dx / rect.width) * 100
                    let newLeft = startLeft + dxPercent
                    newLeft = Math.max(0, Math.min(100 - width, newLeft))
                    gkPositionMap.value = { ...gkPositionMap.value, [element.current_id]: newLeft }
                }

                const onMouseUp = () => {
                    draggingGkId.value = null
                    if (!moved) {
                        elementViewFlag.value = true
                        selectedElement.value = element
                        activeTimeline.value = 'goalkeeper'
                    }
                    document.removeEventListener('mousemove', onMouseMove)
                    document.removeEventListener('mouseup', onMouseUp)
                }

                document.addEventListener('mousemove', onMouseMove)
                document.addEventListener('mouseup', onMouseUp)
            }

            const getPlayerElementStyle = (element) => {
                if (isElementsWithoutTime()) {
                    return { width: (100 / elements.value.length) + '%' }
                }
                return { width: ((100 * element.time) / getFulltimeOfElements()) + '%' }
            }

            const getElementDisplayName = (element) => {
                if (syncLayout.value) {
                    const widthPct = (+element.time / syncLayout.value.totalTime) * 100
                    return widthPct > 8 ? element.name : element.name[0]
                }
                return element.name
            }

            const handleReorder = () => {
                if (selectedElement.value?.current_id) {
                    selectedElement.value = elements.value.find(el => el.current_id === selectedElement.value.current_id) || {}
                }
            }

            const uploadPdfSummary = async () => {
                await getTrainingSummaryPdf(props.summary?.summary_id, props.training.training_id)
            }

            return {
                ageGroup,
                showElements,
                allTrainingElements,
                trainingElements,
                filteredTrainingElements,
                searchQuery,
                page,
                maxPage,
                selectedBlock,
                blockOptions,
                addTraining,
                parseElementType,
                parseAgeGroup,
                parseScoring,
                addElementToTraining,
                elements,
                goalkeeperElements,
                activeTimeline,
                minutes,
                hours,
                elementViewFlag,
                selectedElement,
                deleteElementFromTimeline,
                getFulltimeOfElements,
                isElementsWithoutTime,
                getFulltimeOfGoalkeeperElements,
                isGoalkeeperElementsWithoutTime,
                goalkeeperTimelineTime,
                changeTimeSelectedElement,
                timelineTime,
                trainingName,
                trainingDescription,
                trainingAgeGroup,
                updateTrainingSummary,
                validation,
                errorValidationFlag,
                uploadPdfSummary,
                prevPage,
                nextPage,
                handleReorder,
                syncLayout,
                getPlayerElementStyle,
                getElementDisplayName,
                getGkRailStyle,
                startDragGk,
                draggingGkId,
                changeApproachesSelectedElement,
                changeRestSelectedElement,
                isGoalkeeperTrainer,
                isIndividualTrainer,
                canEditGoalkeeperTimeline
            }
        },

        components: {
            ElementView,
            draggable
        }
    }
</script>

<style lang="scss" scoped>

</style>
